import { PROTOTYPE_MOBILE_PREFIX } from "../mobileRoutePrefix";

/** Jigsaw mobile screenshot shell — isolated routes (no site header). */
export const JIGSAW_MOBILE_TITLE = "Jigsaw Muse";

const JIGSAW_BASE = `${PROTOTYPE_MOBILE_PREFIX}/jigsaw`;

export const MAIN_PATH = JIGSAW_BASE;
export const SCREENSHOT_PATH = `${JIGSAW_BASE}/screenshot/:slug`;

/**
 * 1080p content capture — loads a jigsaw then opens the fixed 1920×1080 capture board.
 * Popup / OBS size: 1920×1080 (see PrototypeMain).
 */
export const RECORDING_CONTENT_PATH = `${JIGSAW_BASE}/recording/1080p`;

/**
 * Fixed 1920×1080 capture play surface (dedicated page — not the service play board).
 * OBS Browser Source and the prototype popup must be exactly 1920×1080.
 */
export const RECORDING_PLAY_PATH = `${JIGSAW_BASE}/recording/1080p/:storyId/board/:jigsawId`;

/**
 * Fixed 1920×1080 Color Basket trailer — hands-free demo of the whole basket flow.
 * Popup / OBS size: 1920×1080 (see PrototypeMain).
 */
export const RECORDING_COLOR_BASKET_PATH = `${JIGSAW_BASE}/recording/1080p/color-basket`;

/**
 * Fixed 1920×1080 Color Basket feature shot — the still that opens the trailer.
 * Popup / OBS size: 1920×1080 (see PrototypeMain).
 */
export const RECORDING_COLOR_BASKET_FEATURE_PATH = `${JIGSAW_BASE}/recording/1080p/color-basket-feature`;

/**
 * Apple App Store content capture — loads a jigsaw then opens the 1290×2796 board.
 * Popup / OBS size: 1290×2796 (see PrototypeMain).
 */
export const RECORDING_APPLE_CONTENT_PATH = `${JIGSAW_BASE}/recording/apple`;

/**
 * Fixed 1290×2796 App Store portrait capture play surface.
 * OBS Browser Source and the prototype popup must be exactly 1290×2796.
 */
export const RECORDING_APPLE_PLAY_PATH = `${JIGSAW_BASE}/recording/apple/:storyId/board/:jigsawId`;

/** @deprecated Prefer {@link RECORDING_PLAY_PATH} for capture; kept for older links. */
export const PLAY_BOARD_PATH = `${JIGSAW_BASE}/play/:storyId/board/:jigsawId`;

/** App Store / Play Store icon capture — 512×512 (golden M jigsaw piece). */
export const APP_ICON_PATH = `${JIGSAW_BASE}/app-icon`;

/** Google Play Feature Graphic capture — 1024×500 (uses screenshot/06 Ocean puzzle). */
export const FEATURE_GRAPHIC_PATH = `${JIGSAW_BASE}/feature-graphic`;

/**
 * 1080p ending capture — feature graphic image shown fully in viewport.
 * Popup size: 1920×1080 (see PrototypeMain).
 */
export const RECORDING_ENDING_PATH = `${JIGSAW_BASE}/recording/ending`;

export function screenshotPath(slug) {
    return `${JIGSAW_BASE}/screenshot/${slug}`;
}

export function recordingPlayPath(storyId, jigsawId) {
    return `${JIGSAW_BASE}/recording/1080p/${encodeURIComponent(storyId)}/board/${encodeURIComponent(jigsawId)}`;
}

export function recordingApplePlayPath(storyId, jigsawId) {
    return `${JIGSAW_BASE}/recording/apple/${encodeURIComponent(storyId)}/board/${encodeURIComponent(jigsawId)}`;
}

export function playBoardPath(storyId, jigsawId) {
    return `${JIGSAW_BASE}/play/${encodeURIComponent(storyId)}/board/${encodeURIComponent(jigsawId)}`;
}
